import { createContext, useContext, useEffect, useState } from 'react';
import { translations } from './translations';

const LanguageContext = createContext(null);

const getInitialLang = () => {
  if (typeof window === 'undefined') return 'en';
  const saved = window.localStorage.getItem('trtb_lang');
  return saved === 'tr' ? 'tr' : 'en';
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);
  const t = translations[lang];

  useEffect(() => {
    window.localStorage.setItem('trtb_lang', lang);
    document.documentElement.lang = lang;
    document.title = t.seo.title;
    const md = document.querySelector('meta[name="description"]');
    if (md) md.setAttribute('content', t.seo.description);
    const ogt = document.querySelector('meta[property="og:title"]');
    if (ogt) ogt.setAttribute('content', t.seo.title);
    const ogd = document.querySelector('meta[property="og:description"]');
    if (ogd) ogd.setAttribute('content', t.seo.description);
  }, [lang, t]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
